module.exports = __webpack_public_path__ + "img/18_107.80b9e6f7.png";